var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"docs"},[_c('DocsMenu',{attrs:{"menu":_vm.menu,"slug":_vm.slug}}),_vm._v(" "),_c('div',{staticClass:"docs__content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.html)}})]),_vm._v(" "),_c('DocsTOC',{attrs:{"toc":_vm.toc}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }